module.exports = require("@mui/material/Stepper");